import { render, staticRenderFns } from "./ShotStyle.vue?vue&type=template&id=25045a43&scoped=true&"
import script from "./ShotStyle.vue?vue&type=script&lang=js&"
export * from "./ShotStyle.vue?vue&type=script&lang=js&"
import style0 from "./ShotStyle.vue?vue&type=style&index=0&id=25045a43&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25045a43",
  null
  
)

export default component.exports